import actionCreatorFactory from 'typescript-fsa';
import { DataLayer } from '@shared/types/data-layer';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const saveTrackingData = actionCreator<DataLayer>('SAVE_TRACKING_DATA');
